<script setup lang="ts">
import { pickTextColorBasedOnBgColor } from 'frontend/ui/functions/pickTextColorBasedOnBgColor'
import type { ILabel } from 'frontend/ui/types/i-label'
import { computed } from 'vue'

interface Props {
  item: ILabel
  additionalClass?: string | object | Array<string | object>
  tooltipContent?: string
}
const props = withDefaults(defineProps<Props>(), {
  item: null,
  additionalClass: '',
})

const fontColor = computed(() => {
  if (props.item.fontColor) {
    return props.item.fontColor
  } else if (props.item.backgroundColor) {
    return pickTextColorBasedOnBgColor(props.item.backgroundColor)
  } else {
    return null
  }
})

const badgeStyle = computed(() => {
  if (!props.item) return {}
  return {
    color: fontColor.value,
    backgroundColor: props.item.backgroundColor,
    borderColor: props.item.borderColor || props.item.backgroundColor,
    borderStyle: 'solid',
  }
})
const computedTooltipContent = computed(() => {
  const result = []
  if (props.item?.archivedAt) {
    result.push('Is archived')
  }
  if (props.item?.description?.length) {
    result.push(props.item.description)
  }
  if (props.tooltipContent) {
    result.push(props.tooltipContent)
  }
  return result.join('\n')
})
</script>

<template lang="pug">
span.erebus-label(
  :class="{ 'line-through': !!item?.archivedAt }"
  v-tooltip="computedTooltipContent"
)
  span.badge.border-1(v-if="item" :class="additionalClass" :id="item.id" :style="badgeStyle") {{ item.name }}
    slot
  span.text-black-15(v-else) empty
</template>

<style lang="scss" scoped>
@use 'sass:map';
@use 'frontend_stylesheets/theme-variables' as themeVariables;

.erebus-label {
  height: 100%;
  display: flex;
  align-items: center;
}
.badge {
  max-width: 100%;
  text-overflow: ellipsis;
  overflow: hidden;
  color: map.get(themeVariables.$colors, outline);
}

.pointer {
  cursor: pointer;
}
</style>
